//Sass
import './sass/main.scss';

//JS
import './js/stark_custom.js';
import './js/navigation.js';
import './js/sliders.js';
import './js/parallax.js';
import './js/contact_location_map.js';
import './js/google_search.js';